import { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { PortalBusinessesServicesSummaryDocument } from '@/graphql/generated/graphql'

/**
 * Resumen de servicios activos por negocio (todos los negocios, no paginado).
 * `cache-first` para no repetir la petición al reentrar a la lista; el botón
 * "Actualizar" hace refetch explícito.
 */
export function useBusinessesServicesSummary() {
  const { data, loading, error, refetch } = useQuery(
    PortalBusinessesServicesSummaryDocument,
    { fetchPolicy: 'cache-first' },
  )

  const summary = data?.portalBusinessesServicesSummary

  const countByBusinessId = useMemo(() => {
    const map = new Map<string, number>()
    for (const b of summary?.businesses ?? []) {
      map.set(String(b.businessId), b.activeServicesCount)
    }
    return map
  }, [summary])

  return {
    countByBusinessId,
    totalActiveServices: summary?.totalActiveServices ?? 0,
    loading,
    error,
    refetch,
  }
}
